import cadernosServicos from './cadernosServicos';
import cmu from './cmu';
import normasTecnicas from './normasTecnicas';
import modelosCadernosServicos from './modelosCadernosServicos';

let children = [
  {
    name: 'Parametros de COM e CA',
    path: '',
    component: () => import('@/views/parametrosComCa/Index.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ name: 'Parametros de COM e CA' }]
    }
  }
];

children = children.concat(cadernosServicos, normasTecnicas, cmu, modelosCadernosServicos);

export default [
  {
    path: '/parametros-com-ca',
    component: () => import('@/views/Index'),
    children
  }
];
